import { createSlice } from "@reduxjs/toolkit";
import { add_NomineeThunk } from "./thunk";

export const initialState = {
  addNomineeData: [],
  addNomineeError: "", 
  addNomineeLoading: false,
};

const Add_Nominee_Detail = createSlice({
  name: "Add_Nominee_Detail",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(add_NomineeThunk.pending, (state) => {
      state.addNomineeLoading = true;
      state.addNomineeData = [];
      state.addNomineeError = "";
    });
    builder.addCase(add_NomineeThunk.fulfilled, (state, action) => {
      state.addNomineeData = action.payload.data;
      state.addNomineeLoading = false;
    });
    builder.addCase(add_NomineeThunk.rejected, (state, action) => {
      state.addNomineeError =
        action.error?.message ||
        action.payload?.message ||
        "An unknown error occurred";
      state.addNomineeLoading = false;
    });
  },
});

export const { apiRequest, apiError } = Add_Nominee_Detail.actions;

export default Add_Nominee_Detail.reducer;
